$(document).ready(function(){ 
  $('#navt').on('click', function(e){
    e.preventDefault();
    if($( window ).width() > 767){
      $('.custom-size-chart').show().animate({opacity: 1 }, 333);
    }else{
      $('.custom-size-chart').show().animate({left: 0, opacity:1 }, 333);
    }
  });

  $('.close-size-chart').click(function(e){
    e.preventDefault();
    if($( window ).width() > 767){
      $('.custom-size-chart').animate({opacity: 0 }, 333, function() {
        $('.custom-size-chart').hide()
      });
    }else{
      $('.custom-size-chart').animate({left: -767, opacity:1 }, 333, function() {
        $('.custom-size-chart').hide()
      });
    }
  });

  $('#height_weight_btn').click(function(e){
    e.preventDefault();
    var height = $('select[name="height-ft"]').val()+$('select[name="height-inch"]').val();
    var weight = $('select[name="weight-lbs"]').val() ; 
    var size = getHeightWeightAnswer(height, weight);

    var sizeTxt = "";
    if(size == 'Not Available'){
      sizeTxt = "<strong>more answers are required</strong>";
    }else{
      sizeTxt = "You're <strong>Size "+ size + "</strong>";
    }

    $('#height_weight_result').val(size);
    $('#showSize').text(size);
    goNext($(this));
  });

  $('#tummy_btn').click(function(e){
    e.preventDefault();
    var prevSize = $('#height_weight_result').val();
    var tummyShape = $('#tummy_selection_tab li.active').text();
    var size = getTummyAnswer(prevSize, tummyShape);
    $('#tummy_result').val(size);
    $('#showSize').text(size);
    goNext($(this));
  });

  $('#chest_btn').click(function(e){
    e.preventDefault();
    var prevSize = $('#tummy_result').val();
    var chestShape = $('#chest_selection_tab li.active').text();

    var size = getChestAnswer(prevSize, chestShape);
    var sizeTxt = "";
    if(size == 'Not Available'){
      sizeTxt = "<strong>more answers are required</strong>";
    }else{
      sizeTxt = "You're <strong>Size "+ size + "</strong>";
    }
    $('#chest_result').val(size);
    $('#showSize').text(size);
    $('.pre-size').html(sizeTxt);
    goNext($(this));
  });

  $('#age_btn').click(function(){
    var age = $('select[name="age-year"]').val();
    $('#age_result').val(age);
    $('#showSize').text(age);
    goNext($(this));
  });
  
  $('#select_size_btn').click(function(){
    if($('#user_selected_size').val() != ""){
      goNext($(this));
    }
  });

  
  $('#fitcheck_btn').click(function(e){
    e.preventDefault();
    var prevSize = $('#chest_result').val();
    var fitSize = $('select[name="fit"]').val();
    var size = getFitAnswer(prevSize, fitSize);

    var sizeTxt = "";
    if(size == 'Not Available'){
      sizeTxt = "<strong>more answers are required</strong>";
    }else{
      sizeTxt = "You're <strong>Size "+ size + "</strong>";
    }
    $('#fit_result').val(size);
    $('#showSize').text(size);
    goNext($(this));


  });
  
  
  $('.select-quality li input[type="radio"]').click(function(){
    var prevSize = $('#chest_result').val();
    var fitSize = $('input[name="fit"]:checked').val();
    var size = getFitAnswer(prevSize, fitSize);
    $('#fit_result').val(size);
    $('#showSize').text(size);
    goNext($(this));

  });

  $('.select-brand li').click(function(){
    var selectedBrand = $(this).attr('data-brand');
    $('.select-brand li').removeClass('active');
    $(this).addClass('active');
    $('.selected-brand').text(selectedBrand);
    $('#showSize').text(selectedBrand);
    goNext($(this));
  });

  $('.custom-size-tab .left-page-section').click(function(){
    $(this).parents('.custom-size-tab').removeClass('tab-active');
    $(this).parents('.custom-size-tab').prev().addClass('tab-active');
  });

  $('.check-selection-tab li').click(function(){
    var dataIdx = $(this).attr('data-index');
    $(this).parent().find('li').removeClass('active');
    $(this).parent().parent().find('.check-selection li').removeClass('active');
    $(this).addClass('active');
    $(this).parent().parent().find('.check-selection li[data-index='+dataIdx+']').addClass('active');
  });

  $('.check-selection-arrow li.Prev').click(function(){
    var prevIdx = 0;
    var slideCount = $(this).parents('.size-content-body').find('.check-selection li').length;
    var currentSlideIdx  = $(this).parents('.size-content-body').find('.check-selection li.active').attr('data-index');
    if(currentSlideIdx == 1){
      prevIdx = slideCount;
    }else{
      prevIdx = parseInt(currentSlideIdx) -1;
    }
    $(this).parents('.size-content-body').find('.check-selection-tab li').removeClass('active');
    $(this).parents('.size-content-body').find('.check-selection li').removeClass('active');

    $(this).parents('.size-content-body').find('.check-selection li[data-index='+prevIdx+']').addClass('active');
    $(this).parents('.size-content-body').find('.check-selection-tab li[data-index='+prevIdx+']').addClass('active');
  });

  $('.check-selection-arrow li.Next').click(function(){
    var nextIdx = 0;
    var slideCount = $(this).parents('.size-content-body').find('.check-selection li').length;
    var currentSlideIdx  = $(this).parents('.size-content-body').find('.check-selection li.active').attr('data-index');
    if(currentSlideIdx == slideCount){
      nextIdx = 1;
    }else{
      nextIdx = parseInt(currentSlideIdx) +1;
    }
    $(this).parents('.size-content-body').find('.check-selection-tab li').removeClass('active');
    $(this).parents('.size-content-body').find('.check-selection li').removeClass('active');

    $(this).parents('.size-content-body').find('.check-selection li[data-index='+nextIdx+']').addClass('active');
    $(this).parents('.size-content-body').find('.check-selection-tab li[data-index='+nextIdx+']').addClass('active');
  });

  $('#select-object-size').click(function(){
    $('.hide-size').slideDown();
  });

  $('.hide-size ul li a').click(function(e){
    e.preventDefault();
    var size = $(this).text();
    $('.hide-size ul li').removeClass('active');
    $(this).parent().addClass('active');
    $('#select-object-size span').text(size);
    $('.selected-size').text(size);
    $('#user_selected_size').val(size);
    $('.hide-size').slideUp(function(){
      $(this).parents('.custom-size-tab').removeClass('tab-active');
      $(this).parents('.custom-size-tab').next().addClass('tab-active');
    });
  });

  $('.size-content-footer .action_button2').click(function(){
    var fSize = false;
    var fChooseSize = false;

    var chooseSize = $('.hide-size ul li.active a').text();
    var size = $('#fit_result').val();

    console.log(chooseSize);
    console.log(size);

    if($('#product-selectors').length){
      $('#product-selectors option').each(function(){
        if($.trim($(this).attr('data-val')) == $.trim(size)){
          fSize = true;
        }
        if($.trim($(this).attr('data-val')) == $.trim(chooseSize)){
          fChooseSize = true;
        }
      });
    }else{
      fSize = true;
      fChooseSize = true;
    }

    $('#firstSelect').parents('.final-size-item').show();


    if(fSize && fChooseSize){

      $("#firstSelect").attr('checked', true);
      $('#firstSelect').val($.trim(size));
      $('#firstSelect').parent().find('.fval').text($.trim(size));

      $('#secondSelect').val($.trim(chooseSize));
      $('#secondSelect').parent().find('.fval').text($.trim(chooseSize));

      $('.show-size').text(size);
      $('.show-percent').text('80%');

      move("firstSelectProgress", 88, 'green');
      move("secondSelectProgress", 75, 'gray');


      $('.nofound-msg').hide();
      $('.default-msg').show();
      console.log(11);
    }else if(fSize && ! fChooseSize){
      //$('#secondSelect').parent().hide();
      //$('#firstSelect').parent().show();

      $("#firstSelect").attr('checked', true);
      $('#firstSelect').val($.trim(size));
      $('#firstSelect').parent().find('.fval').text($.trim(size));

      $('#secondSelect').val($.trim(chooseSize));
      $('#secondSelect').parent().find('.fval').text($.trim(chooseSize));

      $('.show-size').text(size);
      $('.show-percent').text('88%');

      move("firstSelectProgress", 88, 'green');
      move("secondSelectProgress", 40, 'gray');

      $('.nofound-msg').hide();
      $('.default-msg').show();
      console.log(22);
    }else if(! fSize && fChooseSize){

      $("#secondSelect").attr('checked', true);
      $('#firstSelect').val($.trim(size));
      $('#firstSelect').parent().find('.fval').text($.trim(size));
      $('#secondSelect').val($.trim(chooseSize));
      $('#secondSelect').parent().find('.fval').text($.trim(chooseSize));
      $('.show-size').text(chooseSize);
      $('.show-percent').text('88%');

      move("firstSelectProgress", 40, 'gray');
      move("secondSelectProgress", 88, 'green');

      $('.nofound-msg').hide();
      $('.default-msg').show();
      console.log(33);
    }else{
      move("firstSelectProgress", 40, 'gray');
      move("secondSelectProgress", 40, 'gray');
      $('.nofound-msg').show();
      $('.default-msg').hide();
      console.log(44);
    }

    if(size == 'Not Available'){
      $('#firstSelect').parents('.final-size-item').hide();
    }

    var finalSize = $("input[name='chk-final-size']:checked"). val();
    $('.action_button4 span').text(finalSize);

    goNext($(this));
  });

  $('.select-final-size li input[type="radio"]').change(function() {
    var sizeVal = $(this).val();
    if(sizeVal != 'Not Available'){
      $('.action_button4 span').text(sizeVal);
    }
  });

  $('.action_button4').click(function(){
    var finalSize = $("input[name='chk-final-size']:checked"). val();
    var selectBoxVal = "";

    $('#product-selectors option').each(function(){
      if($.trim($(this).attr('data-val')) == $.trim(finalSize)){
        selectBoxVal = $(this).attr('value');
      }
    });

    $('#product-selectors').val(selectBoxVal).trigger('change');
    $('#product-add-to-cart').trigger('click');
    $('.close-size-chart').trigger('click');
  });


  var move = function (idx, wdth, className) {
    var elem = document.getElementById(idx);   
    var width = 1;
    var id = setInterval(frame, 10);
    function frame() {
      if (width >= wdth) {
        clearInterval(id);
      } else {
        width++; 
        elem.style.width = width + '%'; 
        elem.innerHTML = width * 1  + '%';
        elem.classList.remove('gray');
        elem.classList.remove('green');
        elem.classList.add(className);
      }
    }
  };

  var getHeightWeightAnswer = function (height, weight){
    var height = parseFloat(height);
    var weight = parseFloat(weight);
    var size = "";
    
    if(weight >= 125 && weight <= 155){
      if(height >= 507 && height <= 509){
        size = "XS";
      }else{
        size = "Not Available";
      }
    }else if(weight >= 156 && weight <= 170){
      if(height >= 508 && height <= 510){
        size = "S";
      }else{
        size = "Not Available";
      }
    }else if(weight >= 171 && weight <= 185){
      if(height >= 509 && height <= 511){
        size = "M";
      }else{
        size = "Not Available";
      }
    }else if(weight >= 186 && weight <= 195){
      if(height >= 510 && height <= 600){
        size = "L";
      }else{
        size = "Not Available";
      }
    }else if(weight >= 196 && weight <= 210){
      if(height >= 511 && height <= 601){
        size = "XL";
      }else{
        size = "Not Available";
      }
    }else if(weight >= 211 && weight <= 220){
      if(height >= 600 && height <= 603){
        size = "XXL";
      }else{
        size = "Not Available";
      }
    }else{
      size = "Not Available";
    }
    
    return size;
  };

  var getTummyAnswer = function (prevSize, tummyShape){
    var tummyShape = $.trim(tummyShape);
    var newSize = "";
    if(tummyShape == 'Broder'){
      if(prevSize == 'XS'){
        newSize = 'S';
      }else if(prevSize == 'S'){
        newSize = 'M';
      }else if(prevSize == 'M'){
        newSize = 'L';
      }else if(prevSize == 'L'){
        newSize = 'XL';
      }else if(prevSize == 'XL'){
        newSize = 'XXL';
      }else if(prevSize == 'XXL'){
        newSize = 'Not Available';
      }else{
        newSize = "Not Available"
      }
    }else{
      newSize = prevSize;
    }
    return newSize;
  };
  
  var getChestAnswer = function (prevSize, chestShape){
    var chestShape = $.trim(chestShape);
    var anewSize = "";
    if(chestShape == 'Broder'){
      if(prevSize == 'XS'){
        anewSize = 'S';
      }else if(prevSize == 'S'){
        anewSize = 'M';
      }else if(prevSize == 'M'){
        anewSize = 'L';
      }else if(prevSize == 'L'){
        anewSize = 'XL';
      }else if(prevSize == 'XL'){
        anewSize = 'XXL';
      }else if(prevSize == 'XXL'){
        anewSize = 'Not Available';
      }else{
        anewSize = "Not Available"
      }
    }else{
      anewSize = prevSize;
    }
    return anewSize;
  };


  var getFitAnswer = function (prevSize, fitSize){
    var size = "";
    //var prevSize = $.trim(prevSize);
    var fitSize = $.trim(fitSize);
    
    //console.log(prevSize);
    //console.log(fitSize);

    if(prevSize == 'XS'){
      //console.log('XSXSXSXS');
      if(fitSize == 'veryloose'){
        size = "L";
      }else if(fitSize == 'loose'){
        size = "M";
      }else if(fitSize == 'average' || fitSize == 'slightlytight' || fitSize == 'tight'){
        size = "XS";
      }else if(fitSize == 'verytight'){
        size = "Not Available";
      }else{
        size = "Not Available";
      }

    }else if(prevSize == 'S'){
		//console.log('SSSSS');
      if(fitSize == 'veryloose'){
        size = "XL";
      }else if(fitSize == 'loose'){
        size = "L";
      }else if(fitSize == 'average'){
        size = "S";
      }else if(fitSize == 'slightlytight' || fitSize == 'tight'){
        size = "XS";
      }else if(fitSize == 'verytight'){
        size = "Not Available";
      }else{
        size = "Not Available";
      }

    }else if(prevSize == 'M'){
      //console.log('MMMMM');
      if(fitSize == 'veryloose'){
        size = "XXL";
      }else if(fitSize == 'loose'){
        size = "XL";
      }else if(fitSize == 'average'){
        size = "M";
      }else if(fitSize == 'slightlytight' || fitSize == 'tight'){
        size = "S";
      }else if(fitSize == 'verytight'){
        size = "XS";
      }else{
        size = "Not Available";
      }

    }else if(prevSize == 'L'){
      //console.log('LLLLL');
      if(fitSize == 'veryloose'){
        size = "XXL";
      }else if(fitSize == 'loose'){
        size = "XL";
      }else if(fitSize == 'average'){
        size = "L";
      }else if(fitSize == 'slightlytight' || fitSize == 'tight'){
        size = "M";
      }else if(fitSize == 'verytight'){
        size = "S";
      }else{
        size = "Not Available";
      }

    }else if(prevSize == 'XL'){
      //console.log('XLXLXLXL');
      if(fitSize == 'veryloose'){
        size = "Not Available";
      }else if(fitSize == 'loose'){
        size = "XXL";
      }else if(fitSize == 'average'){
        size = "XL";
      }else if(fitSize == 'slightlytight' || fitSize == 'tight'){
        size = "L";
      }else if(fitSize == 'verytight'){
        size = "M";
      }else{
        size = "Not Available";
      }

    }else if(prevSize == 'XXL'){
      //console.log('XXLXXLXXLXXLXXL');
      if(fitSize == 'veryloose'){
        size = "Not Available";
      }else if(fitSize == 'loose'){
        size = "Not Available";
      }else if(fitSize == 'average'){
        size = "XXL";
      }else if(fitSize == 'slightlytight' || fitSize == 'tight'){
        size = "XL";
      }else if(fitSize == 'verytight'){
        size = "L";
      }else{
        size = "Not Available";
      }
    }else{
      size = "Not Available";
    }

    return size;
  };

  var goNext = function(elem){
    elem.parents('.custom-size-tab').removeClass('tab-active');
    elem.parents('.custom-size-tab').next().addClass('tab-active');
  };

});









